export default __webpack_public_path__ + "static/media/849.474042f4.png";